import { SVGProps } from "react";

/**
 * 단순 X 아이콘 (외곽선만, 원형 배경 없음).
 * BottomSheet / 모달 등 컨테이너 자체에 외곽이 이미 있는 곳의 close 버튼 용도.
 * 원형 배경이 필요한 input clear 등은 `CloseCircleIcon` 사용.
 */
const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M11.9995 13.0543L6.92652 18.1275C6.78802 18.2658 6.61394 18.3367 6.40427 18.34C6.19477 18.3432 6.01752 18.2723 5.87252 18.1275C5.72769 17.9825 5.65527 17.8068 5.65527 17.6005C5.65527 17.3942 5.72769 17.2185 5.87252 17.0735L10.9458 12.0005L5.87252 6.9275C5.73419 6.789 5.66336 6.61492 5.66002 6.40525C5.65686 6.19575 5.72769 6.0185 5.87252 5.8735C6.01752 5.72867 6.19319 5.65625 6.39952 5.65625C6.60586 5.65625 6.78152 5.72867 6.92652 5.8735L11.9995 10.9468L17.0725 5.8735C17.211 5.73517 17.3851 5.66433 17.5948 5.661C17.8043 5.65783 17.9815 5.72867 18.1265 5.8735C18.2714 6.0185 18.3438 6.19417 18.3438 6.4005C18.3438 6.60683 18.2714 6.7825 18.1265 6.9275L13.0533 12.0005L18.1265 17.0735C18.2649 17.212 18.3357 17.3861 18.339 17.5958C18.3422 17.8053 18.2714 17.9825 18.1265 18.1275C17.9815 18.2723 17.8059 18.3448 17.5995 18.3448C17.3932 18.3448 17.2175 18.2723 17.0725 18.1275L11.9995 13.0543Z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
